import React from 'react';
import { injectIntl } from 'react-intl';
import { Button } from 'react-bootstrap';

import CmsMedia from 'components/cms/settings/CmsMedia';

const videoTypes = ['video'];

class CmsMediaSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      mouseOver: false,
    };
  }

  close = () => {
    this.setState({ show: false });
  };

  mouseEnter = () => {
    this.setState({ mouseOver: true });
  };

  mouseLeave = () => {
    this.setState({ mouseOver: false });
  };

  resetImage = () => {
    const { type, setParams } = this.props;

    setParams([
      { name: type + 'File', value: null },
      { name: type + 'Name', value: null },
      { name: type + 'Url', value: null },
    ]);
  };

  render() {
    const {
      intl: { messages },
      label,
      type,
      urlType,
      itemId,
      pageId,
      getParamValue,
      setParams,
    } = this.props;
    const { show, mouseOver } = this.state;

    const isVideo = videoTypes.indexOf(type) > -1;

    let background = {};
    let isVideoUploaded = null;
    let videoThumbUrl = null;
    let imageUrl = null;
    const fileId = getParamValue(type + 'File');
    if (isVideo) {
      isVideoUploaded = getParamValue('videoUploaded') === '1';
      videoThumbUrl = getParamValue('videoThumbUrl');
    } else {
      imageUrl = getParamValue(type + 'Url');
      if (imageUrl) {
        background = {
          ...background,
          backgroundImage: 'url(' + imageUrl + ')',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        };
      }
    }

    return (
      <div class="form-group form-group-default" onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave}>
        <label>{label}</label>
        <div style={{ position: 'relative', width: '100%' }}>
          {mouseOver && !!imageUrl && (
            <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
              <Button class="text-danger pull-right" bsSize="xsmall" onClick={this.resetImage}>
                <i class="fa fa-times" />
              </Button>
            </div>
          )}
          <div style={{ position: 'absolute', width: '100%', top: '50%', zIndex: 2 }} class="text-center">
            <div style={{ transform: 'translateY(-50%)' }}>
              <Button onClick={() => this.setState({ show: true })} class="btn-rounded" bsSize="sm">
                <i class="fa fa-cog m-r-10" />
                {messages.settings}
              </Button>
            </div>
          </div>
          {isVideo ? (
            <React.Fragment>
              {isVideoUploaded ? (
                <video controls>
                  <source src={videoThumbUrl} type="video/mp4" />
                </video>
              ) : (
                <div class="relative" style={{ width: '100%', paddingBottom: '56.25%' }} />
              )}
            </React.Fragment>
          ) : (
            <div style={{ width: '100%', paddingBottom: '56.25%', ...background }} />
          )}
        </div>

        <CmsMedia
          mediaType={isVideo ? 'video' : 'image'}
          type={type}
          show={show}
          selectedFile={fileId}
          close={this.close}
          setParams={setParams}
          itemId={itemId}
          pageId={pageId}
          urlType={urlType}
        />
      </div>
    );
  }
}
CmsMediaSelector.defaultProps = {
  type: 'image',
  urlType: 'cms_img',
};

export default injectIntl(CmsMediaSelector);
